import Box from "@material-ui/core/esm/Box";
import CardActionArea from "@material-ui/core/esm/CardActionArea";
import CardContent from "@material-ui/core/esm/CardContent";
import ChevronRight from "@material-ui/icons/esm/ChevronRight";
import clsx from 'clsx';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import useStyles from './styles';
export default function OverviewCard(props) {
  const {
    overviewCard,
    overviewCardLabel
  } = useStyles();
  const {
    push
  } = useHistory();
  const {
    classNames,
    linkHref,
    imgSrc,
    label,
    logo
  } = props;
  const routeDelayDuration = 200;
  const handleClick = () => {
    if (linkHref?.startsWith('http')) {
      window.open(linkHref, '_blank');
      return;
    }
    setTimeout(() => {
      window.scrollTo(0, 0);
      push(linkHref ?? '#');
    }, routeDelayDuration);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardActionArea, {
    className: clsx(overviewCard, ...(classNames ?? [])),
    component: !linkHref?.startsWith('http') ? Link : undefined,
    href: linkHref,
    to: linkHref ?? '#',
    onClick: event => {
      event.preventDefault();
      handleClick();
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement("img", {
    src: imgSrc
  }), label && /*#__PURE__*/React.createElement("h2", {
    className: overviewCardLabel
  }, label, /*#__PURE__*/React.createElement(ChevronRight, null)), logo && /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: 0,
    right: 0,
    width: "auto",
    height: "auto"
  }, logo))));
}
OverviewCard.defaultProps = {
  label: '',
  linkHref: '#',
  classNames: [],
  logo: null
};